import {
  Box,
  Card,
  Divider,
  Grid,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import clsx from "clsx";
import { ButtonCust, SimpleModal } from "../../../widgets";
import {
  calculateCost,
  calculateUnlimitedCost,
  calculateUnlimitedCostMnM,
  PlanProps,
} from "./PlanCard";
import styles from "./S14_PlanCard.module.scss";
import Config from "../../../../config/env.config.json";
import {
  GetCurrencyFixed,
  GetCurrencyFixedToTwo,
} from "../../../../utils/commonFunctions/GetCurrencyFixedToTwo";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useEffect, useState } from "react";
import {
  caclulatePlanCostBasedOnEligibility,
  gtmTagManager,
  isPromotionalLandingPage,
  landingPageInfo,
  promotionalLandingPagePlanName,
  renderTextStyles,
  setCartHeader,
  setPromotionalLandingPage,
  shopWareRedirectionHandler,
  updateCartPayload,
  useNonInitialEffect,
} from "../../../../utils";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutingURLs } from "../../../../config/RoutingURLs";
// import { globalVal } from "../../../../utils/globalValues/globalvalues";
import { gaEvents } from "../../../../Types/GoogleAnalytics";
import _ from "lodash";
import { NutritionLabel } from "../NutritionLabel/NutritionLabel";
import unlimitedPlanDiscount from "../../../../config/discountCouponMNM.json";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import EnvConfig from "../../../../config/env.config.json";
import circularLoaderReach from "../../../../assets/Common/reach_loader.gif";
import { SimTypes } from "../../../../features/checkout/Types";
import {
  addCartItems,
  deleteCartItems,
  getCartItems,
  updateCartItems,
} from "../../../../features/shopWare/shopWareSlice";
export const priceCalculationHandler: any = (
  data: any,
  selectedLine: any = 1,
  coupon: any
) => {
  if (coupon?.discountInDollar) {
    return data?.baseLinePrice - (coupon?.discountInDollar || 0);
  } else {
    return data?.baseLinePrice;
  }
  // let PlanDiscountCost, planPerLinesCost: any;
  // if (data?.isUnlimited) {
  //   const { planCost } = calculateUnlimitedCostMnM(data, selectedLine, false);
  //   PlanDiscountCost = caclulatePlanCostBasedOnEligibility(
  //     planCost,
  //     unlimitedPlanDiscount?.data[0]?.discountInDollar * selectedLine
  //   );
  // } else {
  //   const { planCost } = calculateCost(data, selectedLine);
  //   PlanDiscountCost = caclulatePlanCostBasedOnEligibility(
  //     planCost,
  //     unlimitedPlanDiscount?.data[0]?.discountInDollar * selectedLine
  //   );
  // }
  // planPerLinesCost = PlanDiscountCost / selectedLine;
  // return planPerLinesCost;
};

const T14_PlanCard = (props: PlanProps) => {
  const dispatch: any = useAppDispatch();
  const { configKeys } = useAppSelector((state: any) => state?.activation);
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );

  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedPlanDetail, setSelectedPlanDetail] = useState<any>([]);
  const [filteredPlans, setFilteredPlans] = useState<any>({});
  const [nlPlan, setNlPlan] = useState<any>();
  const [showNlModal, setShowNlModal] = useState(false);
  const [nutritionLabel, setNutritionLabel] = useState({
    show: false,
    name: "",
  });
  const { coupon } = useAppSelector((state: any) => state.checkout);
  const [showLoader, setShowLoader] = useState(false);
  const pathname = location.pathname;
  const {
    plandata,
    planContent,
    tagLabel,
    tagBgColor,
    tagTxtColor,
    selectedLine,
    planSelectionHandler,
    isLandingPage,
  } = props;

  let details: any = localStorage.getItem("customerDetail");
  details = JSON.parse(details);
  const {
    cards_div,
    plans_div,
    plan_page_plan_card,
    current_plan,
    fade_out,
    home_page_plan_card,
    tag,
    wrapper_div,
  } = styles;
  const {
    per_month_text,
    dollar,
    discount_text,
    tax_text,
    bundled_text,
    btn_txt,
    data,
    hd_vid,
    sd_vid,
    line_selected,
    lines_selected,
    checkout_cta,
    of_txt,
    broadBandFacts,
    featureTextColor,
    tax_text_color,
    hotspot_data,
    throttle_speed,
    added,
    more_plan,
    s,
    cart_cta,
  } = planContent.plancardData.cardlabels || {};
  const { mbl_img, video_img, info_img, tet_img, throttle_img } =
    planContent.plancardData;

  const lpdata = localStorage.getItem("landingPageConfigData");
  const configData = lpdata && JSON.parse(lpdata);
  const currentUser = JSON.parse(
    localStorage.getItem("currentuser") || "[]"
  ) as any;
  const { subDomainData } = useAppSelector((state: any) => state?.homepage);
  const [deviceObject, setDeviceObject] = useState({} as any);

  function planDetailFormat(planData?: any) {
    const planArr = [];
    for (const item in planData) {
      planArr.push(planData[item]);
    }
    return planArr;
  }
  useEffect(() => {
    if (Config?.IS_SHOPWARE_ENABLED) {
      dispatch(getCartItems()).then((res?: any) => {
        const lineItems = res?.payload?.data?.lineItems || [];
        const deviceData = [];
        const planData = [];

        for (const item of lineItems) {
          if (item?.payload?.linePreferences) {
            planData.push(...planDetailFormat(item?.payload?.linePreferences));
          } else {
            deviceData.push(item);
          }
        }

        localStorage.setItem(
          "reachSelectedDeviceDetail",
          JSON.stringify(deviceData)
        );

        const obj = {
          deviceTotalQuantity: 0,
          quantity: 0,
          topLabel: "",
        } as any;

        for (let i = 0; i < deviceData.length; i++) {
          obj.deviceTotalQuantity += deviceData?.[i]?.quantity;
          if (i === 0) {
            obj.topLabel = deviceData?.[i]?.label;
            obj.quantity = deviceData?.[i]?.quantity;
          }
        }

        setDeviceObject(obj);
        const existingPlanData = JSON.parse(
          localStorage.getItem("reachSelectedPlanDetail") || "[]"
        );
        const formattedExistingPlanData = existingPlanData.map((item: any) =>
          JSON.stringify(item)
        );
        const formattedPlanData = planData.map((item: any) =>
          JSON.stringify(item)
        );

        const isPlanDataChanged =
          formattedPlanData.length !== formattedExistingPlanData.length ||
          formattedPlanData.some(
            (item: string) => !formattedExistingPlanData.includes(item)
          );
        if (isPlanDataChanged) {
          localStorage.setItem(
            "reachSelectedPlanDetail",
            JSON.stringify(planData)
          );
          setSelectedPlanDetail(planData);
        }
      });
    }
  }, []);

  useNonInitialEffect(() => {
    localStorage.setItem(
      "reachSelectedPlanDetail",
      JSON.stringify(selectedPlanDetail)
    );

    let countByName = count(selectedPlanDetail, (item: any) => {
      return item?.plan?.displayName;
    });
    setFilteredPlans(countByName);
    // EnvConfig?.IS_SHOPWARE_ENABLED && handlePlanInCart();
  }, [selectedPlanDetail]);

  useEffect(() => {
    const createPlanDetail = (
      selectedPlan: object,
      line: number,
      isPrimary: boolean = false
    ) => ({
      line,
      plan: selectedPlan,
      firstName: "",
      lastName: "",
      imei: "",
      simPreference: "",
      isPrimary,
    });
    if (isPromotionalLandingPage()) {
      const selectedPlan = plandata.find(
        (el: any) => el.displayName === Config.LANDINGPAGE_PLAN
      );
      if (selectedPlan) {
        const planData = [createPlanDetail(selectedPlan, 1, true)];
        localStorage.setItem(
          "reachSelectedPlanDetail",
          JSON.stringify(planData)
        );
      }
    }

    if (isLandingPage) {
      const selectedPlan = promotionalLandingPagePlanName().data;
      if (selectedPlan) {
        const planData = [];
        const landingPageInfoData = landingPageInfo();
        if (RoutingURLs?.lpAllPlans !== landingPageInfoData?.route) {
          for (let i = 1; i <= Number(configData?.selectedPlanLine); i++) {
            if (i === 1) {
              planData.push(createPlanDetail(selectedPlan, 1, true));
            } else {
              planData.push(createPlanDetail(selectedPlan, i));
            }
          }
        }

        localStorage.setItem(
          "reachSelectedPlanDetail",
          JSON.stringify(planData)
        );
      }
    }
  }, [configData?.selectedPlanLine]);

  const selectedPlanDetailsData = localStorage.getItem(
    "reachSelectedPlanDetail"
  );
  useEffect(() => {
    if (selectedPlanDetailsData && selectedPlanDetailsData.length > 0) {
      const data = JSON.parse(selectedPlanDetailsData) || [];
      setSelectedPlanDetail(data);
    }
  }, [selectedPlanDetailsData]);

  const count = (ary: any, classifier: any) => {
    classifier = classifier || String;
    return ary.reduce(function (counter: any, item: any) {
      var p = classifier(item);
      counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1;
      return counter;
    }, {});
  };
  const selectPlanHandler = (
    _: any,
    plan: any,
    type?: string,
    firstLine?: boolean
  ) => {
    let planDetails;
    if (type === "add") {
      if (selectedPlanDetail.length + 1 <= configKeys?.MAX_LINES_GROUP) {
        let currentPlan = {
          plan: plan,
          firstName: "",
          lastName: "",
          imei: "",
          simPreference: "",
          isPrimary: "",
        };
        planDetails = [...(selectedPlanDetail || []), currentPlan];
        setSelectedPlanDetail(planDetails);
        localStorage.setItem(
          "reachSelectedPlanDetail",
          JSON.stringify(planDetails)
        );
      }
      if (firstLine) {
        gtmTagManager({
          event: gaEvents?.planSelected,
          click_section: "home",
          plan_name: plan?.displayName,
          plan_cost: plan?.baseLinePrice,
          plan_data: `${plan?.planData}GB`,
          action: `select_plan`,
          number_of_users: selectedPlanDetail.length + 1,
        });
      } else {
        gtmTagManager({
          event: gaEvents?.planSelected,
          click_section: "home",
          plan_name: plan?.displayName,
          plan_cost: plan?.baseLinePrice,
          plan_data: `${plan?.planData}GB`,
          action: `add_line`,
          number_of_users: selectedPlanDetail.length + 1,
        });
      }
    } else if (type === "remove") {
      gtmTagManager({
        event: gaEvents?.planSelected,
        click_section: "home",
        plan_name: plan?.displayName,
        plan_cost: plan?.baseLinePrice,
        plan_data: `${plan?.planData}GB`,
        action: `remove_line`,
        number_of_users: selectedPlanDetail.length - 1,
      });
      let selectedPlans = [...selectedPlanDetail];
      for (let i = 0; i < selectedPlans?.length; i++) {
        if (selectedPlans[i].plan?.displayName === plan?.displayName) {
          selectedPlans?.splice(i, 1);
          break;
        }
      }
      let updatedPlans = [...selectedPlans]; // changing the reference so that component is rerendered
      setSelectedPlanDetail(updatedPlans);
      localStorage.setItem(
        "reachSelectedPlanDetail",
        JSON.stringify(updatedPlans)
      );
    }
    if (Config?.IS_SHOPWARE_ENABLED) {
      handlePlanInCart();
    }
  };

  const handlePlanInCart = () => {
    handleAddorUpdateShopwareCart();
  };
  const handleAddorUpdateShopwareCart = (isButtonClick?: any) => {
    setShowLoader(true);
    let planStoreData: any = localStorage.getItem("reachSelectedPlanDetail");
    planStoreData = JSON.parse(planStoreData);
    let currentuser: any = localStorage.getItem("currentuser");
    currentuser = JSON.parse(currentuser);
    const linePreferenceData: any = {};
    planStoreData &&
      planStoreData.map((data: any, index: any) => {
        linePreferenceData["line" + (index + 1)] = {
          imei: data?.imei ? data.imei?.toString() : "",
          simPreference:
            data?.simPreference === SimTypes.eSim
              ? SimTypes.ESIM
              : SimTypes.phySim,
          plan: data?.plan,
          firstName: data?.firstName,
          lastName: data?.lastName,
          isPrimary: data?.isPrimary,
          reachPlanId: data?.plan.name,
        };
      });

    if (planStoreData?.length < 1) {
      deleteCart();
      setShowLoader(false);
    } else if (planStoreData?.length === 1) {
      handleAddToCartShopware(planStoreData, linePreferenceData, isButtonClick);
    } else {
      handleUpdateCartShopware(isButtonClick);
    }
  };
  const deleteCart = () => {
    let lineItemsInCart: any = localStorage.getItem("lineItems");
    lineItemsInCart = JSON.parse(lineItemsInCart);
    let deletionId: any = lineItemsInCart[0]?.id;
    if (deletionId && lineItemsInCart) {
      dispatch(deleteCartItems(deletionId))?.then((res: any) => {
        if (res) {
          dispatch(getCartItems());
          setShowLoader(false);
        }
      });
    } else {
      setShowLoader(false);
    }
  };
  const handleAddToCartShopware = (
    planStoreData: any,
    linePreferenceData: any,
    isButtonClick?: any
  ) => {
    dispatch(
      addCartItems({
        data: {
          planName: planStoreData?.[0].plan?.displayName,
          reachPlanId: planStoreData?.[0].plan?.name,
          quantity: parseInt(planStoreData?.length),
          price: planStoreData?.[0]?.plan?.baseLinePrice,
          discounts: [
            {
              name: "",
              percentage: "",
              applicability: "",
              eligibilityCriteria: [],
              endPointToVerifyDiscount: "",
              eligibilityStatus: "",
            },
          ],
          linePreferences: linePreferenceData,
          shippingOption: "usps_first_class_mail",
        },
      })
    ).then((resp: any) => {
      if (isButtonClick) {
        if (resp?.payload?.status === 200) {
          setShowLoader(false);

          const addCartResponse = resp?.payload?.data?.data;
          let lineItemsInCart: any = addCartResponse?.lineItems;
          let allProductName =
            lineItemsInCart &&
            lineItemsInCart.map((data: any) => data?.payload?.productNumber);
          let productNumberWithData = allProductName?.filter((data: any) =>
            data.includes("DATA")
          );
          if (allProductName?.length === productNumberWithData?.length) {
            navigate(RoutingURLs.checkout);
          } else {
            shopWareRedirectionHandler(Config?.SHOP_DOMAIN, "cart");
          }
        } else {
          setShowLoader(false);
          navigate(RoutingURLs.checkout);
        }
      } else {
        setShowLoader(false);
      }
    });
  };

  const handleNavigationToCart = (isButtonClick?: any) => {
    if (Config?.IS_SHOPWARE_ENABLED) {
      handleAddorUpdateShopwareCart(isButtonClick);
    } else {
      navigate(RoutingURLs.checkout);
    }
  };

  const handleUpdateCartShopware = (isButtonClick?: any) => {
    //subtracting by 1 because selectedPlanDetail.length is become maximum before come to this function
    if (selectedPlanDetail.length - 1 >= (configKeys?.MAX_LINES_GROUP || 6)) {
      setShowLoader(false);
      return;
    }

    let payload = updateCartPayload();
    dispatch(updateCartItems(payload)).then((resp: any) => {
      if (resp?.payload?.status === 200 && isButtonClick) {
        setShowLoader(false);
        const updateCartResponse = resp?.payload?.data;
        let lineItemsInCart: any = updateCartResponse.lineItems;
        let allProductName =
          lineItemsInCart &&
          lineItemsInCart.map((data: any) => data?.payload?.productNumber);
        let productNumberWithData = allProductName?.filter((data: any) =>
          data.includes("DATA")
        );
        if (allProductName?.length === productNumberWithData?.length) {
          navigate(RoutingURLs.checkout);
        } else {
          shopWareRedirectionHandler(Config?.SHOP_DOMAIN, "cart");
        }
      } else {
        setShowLoader(false);
      }
    });
  };

  const getQuantity = (p: any) => {
    let quantity = 0;
    selectedPlanDetail.forEach((el: any) => {
      return el?.plan?.displayName === p?.displayName && quantity++;
    });
    return quantity;
  };
  const RenderPlanCard = (props: any) => {
    const { el, index, isCurrentPlan, planCost, isNlModal } = props || {};

    return configKeys ? (
      <Card
        id={`home${index}`}
        key={index}
        className={clsx(
          home_page_plan_card,
          plan_page_plan_card,
          isCurrentPlan ? current_plan : ""
        )}
        raised
        elevation={isMobile ? 0 : 8}
        // {...(isNlModal && {
        //   sx: { m: "0px", p: "0px" },
        // })}
        {...(!isNlModal && {
          sx: { borderRadius: "14px" },
        })}
        sx={{
          overflow: {
            xs:
              nutritionLabel.show && nutritionLabel.name === el?.name
                ? "scroll"
                : "revert",
            sm:
              nutritionLabel.show && nutritionLabel.name === el?.name
                ? "scroll"
                : "unset",
          },
          height:
            nutritionLabel.show && nutritionLabel.name === el?.name
              ? "400px"
              : "400px",
          maxHeight: "400px",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          "&-ms-overflow-style:": {
            display: "none",
          },
        }}
      >
        {isCurrentPlan && (
          <>
            {!tagLabel && (
              <Box
                className={tag}
                sx={{
                  backgroundColor: tagBgColor
                    ? tagBgColor
                    : "var(--primary_background)",
                  color: tagTxtColor ? tagTxtColor : "var(--white)",
                }}
              >
                {planContent?.current_plan}
              </Box>
            )}
          </>
        )}
        <Typography
          component={"h5"}
          sx={{
            fontFamily: "var(--font_family_Semibold)",
            fontSize: { xs: "18px", md: "18px" },
            color: "var(--text_color_12)",
            fontWeight: "600",
            my: "6px",
            textAlign: "center",
          }}
        >
          {el.displayName}
        </Typography>
        <Box sx={{ textAlign: "center", minHeight: { xs: "250px" } }}>
          <Typography
            component={"span"}
            sx={{
              fontFamily: "var(--font_family_Bold)",
              fontSize: "26px",
              color: "var(--primary_color)",
            }}
          >
            {el.planData + el.dataUnit}
          </Typography>
          <Typography
            component={"p"}
            sx={{
              // fontSize: "32px",
              fontFamily: "var(--font_family_Bold)",
              // color: "var(--primary_color)",
            }}
          >
            <Typography
              component={"span"}
              sx={{
                fontSize: "20px",
                fontFamily: "var(--font_family_Bold)",
                fontWeight: "var(--font_weight_5) !important",
                color: "inherit",
              }}
            >
              {coupon?.discountInDollar ? (
                <>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Bold)",
                      fontSize: "20px",
                      color: "var(--black)",
                    }}
                  >
                    {dollar}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Bold)",
                      fontSize: "20px",
                      color: "var(--black)",
                    }}
                  >
                    {GetCurrencyFixed(
                      planCost ? planCost - (coupon?.discountInDollar || 0) : 0,
                      el.currency ? el.currency : "usd",
                      true
                    )}
                  </Typography>
                  <Typography
                    component={"span"}
                    sx={{
                      fontFamily: {
                        xs: " var(--font_family_Bold)",
                        sm: "var(--font_family_Semibold)",
                      },
                      fontWeight: {
                        xs: " var(--font_weight_4)",
                        sm: "var(--font_weight_2)",
                      },
                      fontSize: { xs: "20px" },
                      color: "var(--black)",
                    }}
                  >
                    {per_month_text}
                  </Typography>
                  &nbsp;
                  <Typography
                    component="span"
                    sx={{
                      textDecoration: "line-through",
                      color: "var(--text_color_12)",
                      fontWeight: "var(--font_weight_1)",
                      fontFamily: "var(--font_family_SemiBold)",
                      fontSize: "20px",
                    }}
                  >
                    {dollar}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      textDecoration: "line-through",
                      color: "var(--text_color_12)",
                      fontWeight: "var(--font_weight_1)",
                      fontFamily: "var(--font_family_SemiBold)",
                      fontSize: "20px",
                    }}
                  >
                    {GetCurrencyFixed(
                      planCost ? planCost : 0,
                      el.currency ? el.currency : "usd",
                      true
                    )}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Bold)",
                      fontSize: "20px",
                      color: "var(--black)",
                    }}
                  >
                    {dollar}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Bold)",
                      fontSize: "20px",
                      color: "var(--black)",
                    }}
                  >
                    {GetCurrencyFixed(
                      planCost ? planCost : 0,
                      el.currency ? el.currency : "usd",
                      true
                    )}
                  </Typography>
                  <Typography
                    component={"span"}
                    sx={{
                      fontFamily: {
                        xs: " var(--font_family_Bold)",
                        sm: "var(--font_family_Semibold)",
                      },
                      fontWeight: {
                        xs: " var(--font_weight_4)",
                        sm: "var(--font_weight_2)",
                      },
                      fontSize: { xs: "20px" },
                      color: "var(--black)",
                    }}
                  >
                    {per_month_text}
                  </Typography>
                </>
              )}
            </Typography>
            <Typography
              component={"div"}
              sx={{
                fontFamily: "var(--font_family_Regular)",
                fontSize: "12px",
                color: tax_text_color ? tax_text_color : "var(--black)",
                my: "10px",
              }}
            >
              {tax_text}
            </Typography>
            {/* {bundled_text && (
              <Typography
                component={"div"}
                sx={{
                  fontFamily: "var(--font_family_Regular)",
                  fontSize: "12px",
                  color: "var(--black)",
                  my: "10px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {bundled_text}
              </Typography>
            )} */}

            <Typography
              component={"div"}
              sx={{
                fontFamily: "var(--font_family_Regular)",
                fontSize: "12px",
                color: "var(--black)",
                my: "10px",
                width: "90%",
              }}
            >
              {discount_text}
            </Typography>
          </Typography>
          {/* <Typography
            component={"span"}
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              pl: "25px",
              my: "20px",
            }}
          >
            <Box
              component="img"
              alt={mbl_img?.data?.attributes?.alternativeText}
              src={mbl_img?.data?.attributes?.url || ""}
              width="15px"
            />
            <Typography
              component={"span"}
              sx={{
                fontFamily: "var(--font_family_Regular)",
                fontSize: "13px",
                color: featureTextColor
                  ? featureTextColor
                  : "var(--title-color_1)",
                ml: "15px",
              }}
            >
              {el.planData + el.dataUnit + " " + (data ?? "")}
            </Typography>
          </Typography> */}
          <Typography
            component={"span"}
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              pl: "25px",
              my: "20px",
            }}
          >
            <Box
              component="img"
              alt={video_img?.data?.attributes?.alternativeText}
              src={video_img?.data?.attributes?.url || ""}
              width="15px"
            />
            <Typography
              component={"span"}
              sx={{
                fontFamily: "var(--font_family_Regular)",
                fontSize: "13px",
                color: featureTextColor
                  ? featureTextColor
                  : "var(--title-color_1)",
                ml: "15px",
              }}
            >
              {el.streamType === "HD" ? hd_vid : sd_vid}
            </Typography>
          </Typography>
          {el?.tethering && (
            <Typography
              component={"span"}
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                pl: "25px",
                my: "20px",
              }}
            >
              <Box
                component="img"
                alt={tet_img?.data?.attributes?.alternativeText}
                src={tet_img?.data?.attributes?.url || ""}
                width="15px"
              />
              <Typography
                component={"span"}
                sx={{
                  fontFamily: "var(--font_family_Regular)",
                  fontSize: "13px",
                  color: featureTextColor
                    ? featureTextColor
                    : "var(--title-color_1)",
                  ml: "15px",
                }}
              >
                {el?.tethering}
                {hotspot_data}
              </Typography>
            </Typography>
          )}
          {el?.throttleSpeed > 0 ? (
            <Typography
              component={"span"}
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                pl: "25px",
                my: "20px",
              }}
            >
              <Box
                component="img"
                alt={throttle_img?.data?.attributes?.alternativeText}
                src={throttle_img?.data?.attributes?.url || ""}
                width="15px"
              />
              <Typography
                component={"span"}
                sx={{
                  fontFamily: "var(--font_family_Regular)",
                  fontSize: "13px",
                  color: featureTextColor
                    ? featureTextColor
                    : "var(--title-color_1)",
                  ml: "15px",
                }}
              >
                {el?.throttleSpeed}&nbsp;{el?.throttleSpeedUnit}&nbsp;
                {throttle_speed}
              </Typography>
            </Typography>
          ) : null}
        </Box>
        {getQuantity(el) === 0 ? (
          <Box
            className={el.maxLines >= selectedLine ? " " : fade_out}
            sx={{
              display: "flex",
              justifyContent: "center",
              my: "15px",
            }}
          >
            <ButtonCust
              variantType={Config.PRIMARY_BUTTON_TYPE}
              // className={el.maxLines >= selectedLine ? " " : fade_out}
              onClick={(e: any) => {
                // (user && EnvConfig?.IS_SSO_LOGIN) || isSSOToken
                //   ? shareablePlans?.maxLines >= selectedLine
                //     ? selectPlanHandler(e, "byTheGig")
                //     : " "
                //   : (window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`);
                selectPlanHandler(e, el, "add", true);
              }}
              disabled={
                selectedPlanDetail.length >= configKeys?.MAX_LINES_GROUP
              }
              sx={{ minWidth: "150px !important" }}
            >
              {btn_txt}
            </ButtonCust>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              my: "15px",
            }}
            className={clsx(
              configKeys?.MAX_LINES_GROUP >= selectedLine ? " " : fade_out
            )}
          >
            <Box
              sx={{
                display: "flex",
                backgroundColor: "var(--primary_color)",
                justifyContent: "space-around",
                alignItems: "center",
                height: "45px",
                borderRadius: "60px",
                minWidth: "128px",
                width: "150px",
                margin: "auto",
              }}
              className={clsx(
                configKeys?.MAX_LINES_GROUP >= selectedLine ? " " : fade_out
              )}
            >
              <Typography
                sx={{
                  width: "20px",
                  height: "20px",
                  color: "var(--text_color_12)",
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: "var(--white)",
                  border: " 1px solid var(--white)",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: "20px",
                  padding: 0,
                  margin: 0,
                }}
                onClick={(e: any) => {
                  // (user && EnvConfig?.IS_SSO_LOGIN) || isSSOToken
                  //   ? shareablePlans?.maxLines >= selectedLine
                  //     ? selectPlanHandler(e, "byTheGig")
                  //     : " "
                  //   : (window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`);

                  selectPlanHandler(e, el, "remove");
                }}
              >
                <span>-</span>
              </Typography>
              <Typography
                sx={{
                  width: "20%",
                  color: "white",
                  textAlign: "center",
                  fontFamily: "var(--font_family_Semibold)",
                  fontWeight: "var(--font_weight_2)",
                }}
              >
                {getQuantity(el)}
              </Typography>
              <Typography
                sx={{
                  width: "20px",
                  height: "20px",
                  color: "var(--text_color_12)",
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: "var(--white)",
                  border: " 1px solid var(--white)",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: "20px",
                  padding: 0,
                  margin: 0,
                }}
                onClick={(e: any) => {
                  // (user && EnvConfig?.IS_SSO_LOGIN) || isSSOToken
                  //   ? shareablePlans?.maxLines >= selectedLine
                  //     ? selectPlanHandler(e, "byTheGig")
                  //     : " "
                  //   : (window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`);
                  selectPlanHandler(e, el, "add");
                }}
              >
                <span>+</span>
              </Typography>
            </Box>
          </Box>
        )}
        <Divider
          sx={{
            borderColor: "var(--cascading-white)",
            mb: "10px",
            mx: { xs: "-20px", sm: "-10px" },
          }}
        />
        <Box
          sx={{
            display:
              isNlModal && planContent?.res?.broadFactsSectionModal
                ? "none"
                : "flex",
            justifyContent: "center",
            mx: "auto",
            gap: "4px",
            cursor: `${isNlModal ? "normal" : "pointer"}`,
            width: "max-content",
            alignItems: "center",
          }}
          onClick={() => {
            setNutritionLabel((prevState) => ({
              ...prevState,
              show: prevState.show
                ? nutritionLabel.name === el?.name
                  ? false
                  : true
                : true,
              name: el?.name,
            }));
            if (isNlModal) null;
            else {
              setNlPlan(el);
              // setShowNlModal(true);
            }
          }}
        >
          <Typography
            component={"span"}
            sx={_.merge(renderTextStyles(2, "14px", "primary_color", "21px"), {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            })}
          >
            {broadBandFacts}
          </Typography>
          {/* {isNlModal ? (
            <KeyboardArrowUp sx={{ color: "var(--primary_color)" }} />
          ) : (
            <InfoOutlinedIcon
              sx={{
                width: "12px",
                height: "12px",
                color: "var(--primary_color)",
              }}
            />
            // <Box
            //   component={"img"}
            //   width={"11px"}
            //   alt={info_img?.data?.attributes?.alternativeText}
            //   src={info_img?.data?.attributes?.url}
            // />
          )} */}
          {nutritionLabel.show ? (
            nutritionLabel.name === el?.name ? (
              <KeyboardArrowUp sx={{ color: "var(--primary_color)" }} />
            ) : (
              <KeyboardArrowDown sx={{ color: "var(--primary_color)" }} />
            )
          ) : (
            <KeyboardArrowDown sx={{ color: "var(--primary_color)" }} />
          )}
        </Box>

        {nutritionLabel.show && nutritionLabel.name === el?.name ? (
          <NutritionLabel
            {...{
              plandata,
              priceCalculationHandler,
            }}
            nlPlan={el}
            selectedLine={1}
          />
        ) : null}
      </Card>
    ) : (
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            margin: "10px 15px 15px 15px",
            maxWidth: "250px",
            backgroundColor: "var(--white)",
            padding: "20px",
            gap: "10px",
          }}
          className={clsx(
            home_page_plan_card,
            plan_page_plan_card,
            isCurrentPlan ? current_plan : ""
          )}
        >
          <Skeleton variant="text" width={30} height={20} />
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={150} height={20} />
          <Skeleton variant="rounded" width={200} height={60} />
          <Box sx={{ display: "flex" }}>
            <Skeleton variant="rounded" width={20} height={30} />
            <Skeleton
              variant="text"
              width={75}
              height={20}
              sx={{ ml: "10px", padding: "10px 0px 0px" }}
            />
          </Box>
          <Box sx={{ display: "flex" }}>
            <Skeleton variant="rounded" width={20} height={30} />
            <Skeleton
              variant="text"
              width={75}
              height={20}
              sx={{ ml: "10px", padding: "10px 0px 0px" }}
            />
          </Box>

          <Skeleton variant="text" width={75} height={30} />
          <Box sx={{ display: "flex", textAlign: "center" }}>
            <Skeleton variant="rounded" width={150} height={10} />
            <Skeleton variant="circular" width={5} height={5} />
          </Box>
        </Box>
      </>
    );
  };

  return (
    <>
      {EnvConfig?.IS_SHOPWARE_ENABLED && showLoader && (
        <Box
          sx={{
            opacity: 0.8,
            backgroundColor: "var(--white)",
            position: "fixed",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            zIndex: 1100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {EnvConfig?.BRAND_NAME === "reach-att" ||
          EnvConfig?.BRAND_NAME === "reach-vzl" ? (
            <Box
              component="img"
              alt={"circular_loader"}
              src={circularLoaderReach}
            />
          ) : null}
        </Box>
      )}
      <Stack className={wrapper_div}>
        <Grid container className={clsx(cards_div, plans_div)}>
          {plandata.length > 0 &&
            plandata.map((el: any, index: number) => {
              const isLpUnlimitedPage =
                pathname === Config.UNLIMITED_LANDING_URL1;
              const shouldRenderCard =
                !isLandingPage &&
                (!isLpUnlimitedPage ||
                  el.displayName === Config.LANDINGPAGE_PLAN);
              const { planCost, planPerLinesCost } = el?.unlimited
                ? calculateUnlimitedCost(el, selectedLine)
                : calculateCost(el, selectedLine);
              const isCurrentPlan =
                details?.reachPlanDisplayName === el?.displayName;

              const landingPagePlan =
                isLandingPage &&
                (el?.displayName === promotionalLandingPagePlanName()?.name ||
                  promotionalLandingPagePlanName()?.name === "All Plan");
              return (
                (shouldRenderCard || landingPagePlan) && (
                  <RenderPlanCard
                    {...{ el, index, selectedLine, isCurrentPlan, planCost }}
                    key={index}
                  />
                )
              );
            })}
          {selectedPlanDetail.length > 0 ||
          deviceObject?.deviceTotalQuantity ? (
            <Box
              sx={{
                backgroundColor: "var(--white)",
                width: "100%",
                // padding: "10px 0px",
                position: "fixed",
                left: 0,
                bottom: "0px",
                // height: { xs: "auto" },
                zIndex: "999",
                boxShadow: "0px 0px 4px 2px #00000026",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", sm: "space-between" },
                  flexDirection: { xs: "column", sm: "row" },
                  padding: { xs: "1.25rem 1.25rem", sm: "1.75rem 1.25rem" },
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: { xs: "flex-start", sm: "flex-start" },
                        justifyContent: "center",
                        flexDirection: "column",
                        width: { xs: "100%", sm: "fit-content" },
                        // borderLeft: { xs: "none", md: "1px solid #004282" },
                      }}
                    >
                      {filteredPlans &&
                        Object.keys(filteredPlans).length > 0 && (
                          <Typography
                            sx={{
                              fontSize: "1rem",
                              lineHeight: "1.5rem",
                              fontWeight: "var(--font_weight_2)",
                              fontFamily: "var(--font_family_Bold) !important",
                              padding: "2px",
                              color: "var(--dark-charcoal-fade)",
                              paddingX: { xs: "0", sm: "2.5rem" },
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <span>{Object.keys(filteredPlans)[0]}</span>
                            {selectedPlanDetail?.length > 1 ? (
                              <Typography
                                component="span"
                                sx={{
                                  fontSize: "0.875rem",
                                  lineHeight: "1.25rem",
                                  fontWeight: "var(--font_weight_1)",
                                  fontFamily: "var(--font_family_Regular)",
                                  color: "var(--dark-charcoal-fade)",
                                  marginLeft: "4px",
                                }}
                              >
                                + {selectedPlanDetail?.length - 1} {more_plan}
                                {selectedPlanDetail?.length - 1 > 1
                                  ? `${s}`
                                  : ""}{" "}
                                {added}
                              </Typography>
                            ) : (
                              <Typography
                                component="span"
                                sx={{
                                  fontSize: "0.875rem",
                                  lineHeight: "1.25rem",
                                  fontWeight: "var(--font_weight_1)",
                                  fontFamily: "var(--font_family_Regular)",
                                  color: "var(--dark-charcoal-fade)",
                                  marginLeft: "4px",
                                }}
                              >
                                {` plan ${added}`}
                              </Typography>
                            )}
                          </Typography>
                        )}
                    </Box>

                    {selectedPlanDetail.length > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          // alignItems: "center",
                          flexDirection: "column",
                          alignSelf: "flex-start",
                          paddingX: { xs: "0", sm: "2.5rem" },
                        }}
                      >
                        <Typography
                          sx={{
                            display: "flex",
                            color: "var(--dark-charcoal-fade)",
                            fontSize: "0.875rem",
                            lineHeight: "1.25rem",
                            fontFamily: "var(--font_family_Medium)",
                            fontWeight: "var(--font_weight_1)",
                          }}
                        >
                          {selectedPlanDetail.length} {of_txt}{" "}
                          {configKeys?.MAX_LINES_GROUP} {lines_selected}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  {deviceObject?.deviceTotalQuantity ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: { xs: "flex-start", sm: "flex-start" },
                          justifyContent: "center",
                          flexDirection: "column",
                          width: { xs: "100%", sm: "fit-content" },
                          // borderLeft: { xs: "none", md: "1px solid #004282" },
                        }}
                      >
                        {/* {filteredPlans && Object.keys(filteredPlans).length > 0 && ( */}
                        <Typography
                          sx={{
                            fontSize: "1rem",
                            lineHeight: "1.5rem",
                            fontWeight: "var(--font_weight_2)",
                            fontFamily: "var(--font_family_Bold) !important",
                            padding: "2px",
                            color: "var(--dark-charcoal-fade)",
                            pl: { xs: "0", sm: "0" },
                            pr: { xs: "0", sm: "2.5rem" },
                            display: "flex",
                            alignItems: "baseline",
                          }}
                        >
                          <span>
                            {/* {filteredPlans[Object.keys(filteredPlans)[0]]}{" "}
                            {Object.keys(filteredPlans)[0]} */}
                            {deviceObject?.topLabel}
                          </span>
                          {deviceObject?.deviceTotalQuantity - 1 > 0 ? (
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "0.875rem",
                                lineHeight: "1.25rem",
                                fontWeight: "var(--font_weight_1)",
                                fontFamily: "var(--font_family_Regular)",
                                color: "var(--dark-charcoal-fade)",
                                marginLeft: "4px",
                              }}
                            >
                              + {deviceObject?.deviceTotalQuantity - 1}{" "}
                              {"more device"}
                              {deviceObject?.deviceTotalQuantity - 1 > 1
                                ? `${s}`
                                : ""}{" "}
                              {added}
                            </Typography>
                          ) : (
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "0.875rem",
                                lineHeight: "1.25rem",
                                fontWeight: "var(--font_weight_1)",
                                fontFamily: "var(--font_family_Regular)",
                                color: "var(--dark-charcoal-fade)",
                                marginLeft: "4px",
                              }}
                            >
                              {` device ${added}`}
                            </Typography>
                          )}
                        </Typography>
                        {/* )} */}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          // alignItems: "center",
                          flexDirection: "column",
                          alignSelf: "flex-start",
                          pl: { xs: "0", sm: "0" },
                          pr: { xs: "0", sm: "2.5rem" },
                        }}
                      >
                        <Typography
                          sx={{
                            display: "flex",
                            color: "var(--dark-charcoal-fade)",
                            fontSize: "0.875rem",
                            lineHeight: "1.25rem",
                            fontFamily: "var(--font_family_Medium)",
                            fontWeight: "var(--font_weight_1)",
                          }}
                        >
                          {deviceObject?.deviceTotalQuantity} {of_txt}{" "}
                          {configKeys?.MAX_LINES_GROUP} {"device added"}
                        </Typography>
                      </Box>
                    </Box>
                  ) : null}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "center" },
                    marginTop: { xs: "20px", md: "0" },
                  }}
                >
                  <ButtonCust
                    sx={{
                      width: { xs: "100%", sm: "250px" },
                      marginBottom: { xs: "0px", sm: "0px" },
                    }}
                    variantType={Config.PRIMARY_BUTTON_TYPE}
                    data-testid="selectPlanHandlerissimpaid"
                    onClick={(e: any) => {
                      handleNavigationToCart(true);
                      setPromotionalLandingPage(
                        pathname === Config.UNLIMITED_LANDING_URL1
                      );
                      setCartHeader(true);
                      gtmTagManager({
                        event: gaEvents?.proceedToLineDetails,
                        click_section: "home",
                        total_line_selected: selectedPlanDetail.length,
                      });
                    }}
                  >
                    {cart_cta}
                  </ButtonCust>
                </Box>
              </Box>
            </Box>
          ) : null}
          {isMobile && (
            <Typography
              component={"div"}
              style={{
                opacity: 0,
              }}
            >
              div
            </Typography>
          )}
          {nlPlan ? (
            <SimpleModal
              isShowModal={showNlModal}
              onCloseModal={() => setShowNlModal(false)}
              showClose={true}
              sx={{
                width: {
                  xs: "270px",
                  sm: "70%",
                  md: "30%",
                  lg: "270px",
                },
                maxWidth: "300px",
                px: "0px !important",
                pt: "37px !important",
              }}
            >
              <>
                <RenderPlanCard
                  el={nlPlan}
                  index={plandata.findIndex(
                    (data: any) => data.name === nlPlan?.name
                  )}
                  isCurrentPlan={false}
                  planCost={
                    nlPlan?.unlimited
                      ? calculateUnlimitedCost(nlPlan, selectedLine)["planCost"]
                      : calculateCost(nlPlan, selectedLine)["planCost"]
                  }
                  isNlModal={true}
                />
                <NutritionLabel
                  NLContent={planContent}
                  {...{
                    plandata,
                    priceCalculationHandler,
                    selectedLine,
                    nlPlan,
                  }}
                  planCost={
                    nlPlan?.unlimited
                      ? calculateUnlimitedCost(nlPlan, selectedLine)["planCost"]
                      : calculateCost(nlPlan, selectedLine)["planCost"]
                  }
                />
              </>
            </SimpleModal>
          ) : null}
        </Grid>
      </Stack>
    </>
  );
};

export default T14_PlanCard;
